import { getDefaultBuConfig, getDefaultBuConfigElement } from "domain/repository/apiUtil";
import _ from "lodash";
import { ChargeDetailConstant } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailConstant";
import { CriteriaDirectoryChargeCheckboxOption } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailCriteriaDirectoryCheckboxOption";
import { adjTypeForSearchDropdownOption, state2DropdownOption, statusDropdownOptions } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { useChargeDetailTracked } from "presentation/store/ChargeDetailMaintenance/ChargeDetailProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { FieldType, HPHInputMask, IFieldValue } from "veronica-ui-component/dist/component/core";

const ChargeSearchForm = () => {
    const CONTAINER_CONSTANT = ChargeDetailConstant.Charge;
    const [chargeDetailState] = useChargeDetailTracked();
    const chargeDetailsearchCriteria = chargeDetailState.searchCriteria;
    const chargeDetailVM = useChargeDetailVM();
    const enabledCriteria = useMemo(() => CriteriaDirectoryChargeCheckboxOption?.find(item => chargeDetailState.enabledSearchCriteria[item.key]), [chargeDetailState.enabledSearchCriteria])
    const isRailEnabled: boolean = getDefaultBuConfigElement<boolean>("REACT_APP_FIELD_ENABLE", "RAIL") || false;
    const isRailMaster: boolean = getDefaultBuConfig<boolean>('REACT_APP_RAIL_ENABLE') || false;
    chargeDetailState.enabledSearchCriteria.trainId = isRailEnabled && isRailMaster;
    const memoSubChgTypeOptions = useMemo(() => {
        if (!chargeDetailsearchCriteria.chargeTypes || chargeDetailsearchCriteria.chargeTypes.length === 0) {
            const allCommonSubChgTypeOptions = Object.values(chargeDetailState.dynamicOptions.subChgTypeDropdownOptions).flat();
            return _.orderBy(_.uniqBy(_.flatMap(_.concat(allCommonSubChgTypeOptions ?? [])), 'value'), 'dropdownLabel');
        }
        const groupOfSubChgTypeOptions = chargeDetailsearchCriteria.chargeTypes?.map(chgType => chargeDetailState.dynamicOptions.subChgTypeDropdownOptions[chgType]);
        const commonSubChgTypeOptions = _.orderBy(_.uniqBy(_.flatMap(_.concat(groupOfSubChgTypeOptions ?? [])), 'value'), 'dropdownLabel');
        return commonSubChgTypeOptions;
    }, [chargeDetailsearchCriteria.chargeTypes, chargeDetailState.dynamicOptions.subChgTypeDropdownOptions])

    const memoChgType = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.chargeTypes?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.chargeTypes}
                fieldLabel={CONTAINER_CONSTANT.CHARGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeTypes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDetailState.dynamicOptions.chgTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.chargeTypes, chargeDetailState.dynamicOptions.chgTypeDropdownOptions, chargeDetailVM, CONTAINER_CONSTANT.CHARGE_TYPE])
    const memoSubChgType = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.subChargeTypes?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.subChargeTypes}
                fieldLabel={CONTAINER_CONSTANT.SUB_CHARGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'subChargeTypes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={memoSubChgTypeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.subChargeTypes, chargeDetailVM, memoSubChgTypeOptions, CONTAINER_CONSTANT.SUB_CHARGE_TYPE])
    const memoBillToCompany = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.billToCompanies?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.billToCompanies}
                fieldLabel={CONTAINER_CONSTANT.BILL_TO_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompanies'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDetailState.dynamicOptions.billToCompDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.billToCompanies, chargeDetailVM, chargeDetailState.dynamicOptions.billToCompDropdownOptions, CONTAINER_CONSTANT.BILL_TO_COMPANY])
    const memoChargeOnCompany = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.chargeOnCompanies?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.chargeOnCompanies}
                fieldLabel={CONTAINER_CONSTANT.CHARGE_ON_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeOnCompanies'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDetailState.dynamicOptions.chgOnCompDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.chargeOnCompanies, chargeDetailVM, chargeDetailState.dynamicOptions.chgOnCompDropdownOptions, CONTAINER_CONSTANT.CHARGE_ON_COMPANY])
    const memoState = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.states?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.states}
                fieldLabel={CONTAINER_CONSTANT.STATE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'states'}
                maxLength={60}
                isMultipleDropDown={true}
                options={state2DropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.states, chargeDetailVM, CONTAINER_CONSTANT.STATE])

    const memoCntrNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "430px", width: '100%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                helpTextElement={"Use line break ( Enter ) as delimiter"}
                readOnlyValue={chargeDetailsearchCriteria.cntrNos?.join('\n') || ''}
                fieldValue={chargeDetailsearchCriteria?.cntrNos?.join('\n')}
                fieldLabel={CONTAINER_CONSTANT.CNTR_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXTAREA}
                fieldKey={'cntrNos'}
                maxLength={780}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.cntrNos, chargeDetailVM, CONTAINER_CONSTANT.CNTR_NO])

    const memoSize = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.cntrSizes?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.cntrSizes}
                fieldLabel={CONTAINER_CONSTANT.SIZE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrSizes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDetailState.dynamicOptions.sizeGroupDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.cntrSizes, chargeDetailVM, chargeDetailState.dynamicOptions.sizeGroupDropdownOptions, CONTAINER_CONSTANT.SIZE])
    const memoType = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.cntrTypes?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.cntrTypes}
                fieldLabel={CONTAINER_CONSTANT.TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrTypes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDetailState.dynamicOptions.typeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.cntrTypes, chargeDetailVM, chargeDetailState.dynamicOptions.typeDropdownOptions, CONTAINER_CONSTANT.TYPE])
    const memoInvNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.docNo || ''}
                fieldValue={chargeDetailsearchCriteria.docNo}
                fieldLabel={CONTAINER_CONSTANT.INV_CRE_NOTE_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'docNo'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.docNo, chargeDetailVM, CONTAINER_CONSTANT.INV_CRE_NOTE_NO])
    const memoAdjType = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.adjTypes?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.adjTypes}
                fieldLabel={CONTAINER_CONSTANT.ADJ_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'adjTypes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={adjTypeForSearchDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.adjTypes, chargeDetailVM, CONTAINER_CONSTANT.ADJ_TYPE])

    const memoCntrStatus = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.cntrStatus?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.cntrStatus}
                fieldLabel={CONTAINER_CONSTANT.CNTR_STATUS}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrStatus'}
                maxLength={60}
                isMultipleDropDown={true}
                options={statusDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.CNTR_STATUS, chargeDetailsearchCriteria.cntrStatus, chargeDetailVM])

    const memoOpsLine = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%'/*, marginBottom: isRailMaster && isRailEnabled ? "0px" : "20px"*/ }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.opsLines?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.opsLines}
                fieldLabel={CONTAINER_CONSTANT.OPS_LINE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'opsLines'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDetailState.dynamicOptions.opsLineDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.OPS_LINE, chargeDetailState.dynamicOptions.opsLineDropdownOptions, chargeDetailVM, chargeDetailsearchCriteria?.opsLines])
    const memoSeqNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.displaySequence || ''}
                fieldValue={chargeDetailsearchCriteria.displaySequence}
                fieldLabel={CONTAINER_CONSTANT.SEQ}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'displaySequence'}
                maxLength={50}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.displaySequence, chargeDetailVM, CONTAINER_CONSTANT.SEQ])
    const memoPOO = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.poo || ''}
                fieldValue={chargeDetailsearchCriteria.poo}
                fieldLabel={CONTAINER_CONSTANT.POO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'poo'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.poo, chargeDetailVM, CONTAINER_CONSTANT.POO])
    const memoPOL = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.pol || ''}
                fieldValue={chargeDetailsearchCriteria.pol}
                fieldLabel={CONTAINER_CONSTANT.POL}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'pol'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.pol, chargeDetailVM, CONTAINER_CONSTANT.POL])
    const memoPOD = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.pod || ''}
                fieldValue={chargeDetailsearchCriteria.pod}
                fieldLabel={CONTAINER_CONSTANT.POD}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'pod'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.pod, chargeDetailVM, CONTAINER_CONSTANT.POD])
    const memoFD = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.fd || ''}
                fieldValue={chargeDetailsearchCriteria.fd}
                fieldLabel={CONTAINER_CONSTANT.FD}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'fd'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.fd, chargeDetailVM, CONTAINER_CONSTANT.FD])
    const memoForwarder = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '100%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.forwarderShipperConsignees?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.forwarderShipperConsignees}
                fieldLabel={CONTAINER_CONSTANT.FORWARDER_SHIPPER_CONSIGNEE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'forwarderShipperConsignees'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDetailState.dynamicOptions.forwarderCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.FORWARDER_SHIPPER_CONSIGNEE, chargeDetailsearchCriteria.forwarderShipperConsignees, chargeDetailState.dynamicOptions.forwarderCodeDropdownOptions, chargeDetailVM])
    const memoChargeCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.chargeCodes?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.chargeCodes}
                fieldLabel={CONTAINER_CONSTANT.CHARGE_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeCodes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDetailState.dynamicOptions.chargeCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.CHARGE_CODE, chargeDetailsearchCriteria.chargeCodes, chargeDetailState.dynamicOptions.chargeCodeDropdownOptions, chargeDetailVM])
    const memoTruckerName = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.truckerName || ''}
                fieldValue={chargeDetailsearchCriteria.truckerName}
                fieldLabel={CONTAINER_CONSTANT.TRUCKER_NAME}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'truckerName'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.truckerName, chargeDetailVM, CONTAINER_CONSTANT.TRUCKER_NAME])
    const memoCNICNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.cnicNo || ''}
                fieldValue={chargeDetailsearchCriteria.cnicNo}
                fieldLabel={CONTAINER_CONSTANT.CNIC_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'cnicNo'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.cnicNo, chargeDetailVM, CONTAINER_CONSTANT.CNIC_NO])
    const memoVehicleNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.vehicleNo || ''}
                fieldValue={chargeDetailsearchCriteria.vehicleNo}
                fieldLabel={CONTAINER_CONSTANT.VEHICLE_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'vehicleNo'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.vehicleNo, chargeDetailVM, CONTAINER_CONSTANT.VEHICLE_NO])
    const memoDamageType = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.damageTypes?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.damageTypes}
                fieldLabel={CONTAINER_CONSTANT.DAMAGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'damageTypes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDetailState.dynamicOptions.damageTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.DAMAGE_TYPE, chargeDetailsearchCriteria.damageTypes, chargeDetailState.dynamicOptions.damageTypeDropdownOptions, chargeDetailVM])
    const memoStorageMode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.storageModes?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.storageModes}
                fieldLabel={CONTAINER_CONSTANT.STORAGE_MODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'storageModes'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDetailState.dynamicOptions.storageModeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.STORAGE_MODE, chargeDetailsearchCriteria.storageModes, chargeDetailState.dynamicOptions.storageModeDropdownOptions, chargeDetailVM])
    const memoOriStatus = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.oriStatus?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.oriStatus}
                fieldLabel={CONTAINER_CONSTANT.ORI_STATUS}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'oriStatus'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDetailState.dynamicOptions.cntrStatusDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.ORI_STATUS, chargeDetailsearchCriteria.oriStatus, chargeDetailState.dynamicOptions.cntrStatusDropdownOptions, chargeDetailVM])
    const memoNewStatus = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria?.newStatus?.join(',')}
                fieldValue={chargeDetailsearchCriteria?.newStatus}
                fieldLabel={CONTAINER_CONSTANT.NEW_STATUS}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'newStatus'}
                maxLength={60}
                isMultipleDropDown={true}
                options={chargeDetailState.dynamicOptions.cntrStatusDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [CONTAINER_CONSTANT.NEW_STATUS, chargeDetailsearchCriteria.newStatus, chargeDetailState.dynamicOptions.cntrStatusDropdownOptions, chargeDetailVM])
    const memoServiceOrderCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.serviceOrderCode || ''}
                fieldValue={chargeDetailsearchCriteria.serviceOrderCode}
                fieldLabel={CONTAINER_CONSTANT.SO_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'serviceOrderCode'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.serviceOrderCode, chargeDetailVM, CONTAINER_CONSTANT.SO_CODE])
    const memoServiceOrderNumber = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.serviceOrderNumber || ''}
                fieldValue={chargeDetailsearchCriteria.serviceOrderNumber}
                fieldLabel={CONTAINER_CONSTANT.SO_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'serviceOrderNumber'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.serviceOrderNumber, chargeDetailVM, CONTAINER_CONSTANT.SO_NO])
    const memoServiceRequestCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.serviceRequestCode || ''}
                fieldValue={chargeDetailsearchCriteria.serviceRequestCode}
                fieldLabel={CONTAINER_CONSTANT.SERVICE_REQUEST_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'serviceRequestCode'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.serviceRequestCode, chargeDetailVM, CONTAINER_CONSTANT.SERVICE_REQUEST_CODE])
    const memoSubServiceRequestCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "180px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.subServiceRequestCode || ''}
                fieldValue={chargeDetailsearchCriteria.subServiceRequestCode}
                fieldLabel={CONTAINER_CONSTANT.SUB_SERVICE_REQUEST_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'subServiceRequestCode'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.subServiceRequestCode, chargeDetailVM, CONTAINER_CONSTANT.SUB_SERVICE_REQUEST_CODE])
    const memoServiceRequestRef = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.serviceRequestRef || ''}
                fieldValue={chargeDetailsearchCriteria.serviceRequestRef}
                fieldLabel={CONTAINER_CONSTANT.SERVICE_REQUEST_REF}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'serviceRequestRef'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.serviceRequestRef, chargeDetailVM, CONTAINER_CONSTANT.SERVICE_REQUEST_REF])
    const memoBillOfLading = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.billOfLadingNo || ''}
                fieldValue={chargeDetailsearchCriteria.billOfLadingNo}
                fieldLabel={CONTAINER_CONSTANT.BL_REF_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'billOfLadingNo'}
                maxLength={35}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.billOfLadingNo, chargeDetailVM, CONTAINER_CONSTANT.BL_REF_NO])
    const memoShippingBill = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.shippingBill || ''}
                fieldValue={chargeDetailsearchCriteria.shippingBill}
                fieldLabel={CONTAINER_CONSTANT.SHIPPING_BILL}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'shippingBill'}
                maxLength={35}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.shippingBill, chargeDetailVM, CONTAINER_CONSTANT.SHIPPING_BILL])
    const memoAgentNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.agentNo || ''}
                fieldValue={chargeDetailsearchCriteria.agentNo}
                fieldLabel={CONTAINER_CONSTANT.AGENT_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'agentNo'}
                maxLength={50}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.agentNo, chargeDetailVM, CONTAINER_CONSTANT.AGENT_NO])
    const memoOpsDateFromTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "430px", width: '100%' }}>
            <DateRangePickerComponent
                label={CONTAINER_CONSTANT.OPS_DATE_RANGE}
                width="100%"
                fieldNames={{ startField: "opsDateFrom", endField: "opsDateTo" }}
                dateRange={{ startDate: chargeDetailsearchCriteria.opsDateFrom, endDate: chargeDetailsearchCriteria.opsDateTo }}
                onDatesChange={chargeDetailVM.onDateRangeChange}
            />
        </div>
        , [chargeDetailsearchCriteria.opsDateFrom, chargeDetailsearchCriteria.opsDateTo, chargeDetailVM, CONTAINER_CONSTANT.OPS_DATE_RANGE])
    const memoTrainId = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: '47.5%' }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDetailsearchCriteria.trainId || ''}
                fieldValue={chargeDetailsearchCriteria.trainId}
                fieldLabel={CONTAINER_CONSTANT.TRAIN_ID}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'trainId'}
                maxLength={12}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [chargeDetailsearchCriteria.trainId, chargeDetailVM, CONTAINER_CONSTANT.TRAIN_ID])
    const memoCoVslVoyVesselName = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "430px", width: '100%' }}>
            <HPHInputMask
                label={CONTAINER_CONSTANT.CONS_VSL_VOY_VESSEL_NAME}
                width={'100%'}
                value={{
                    co: chargeDetailsearchCriteria.co ?? '',
                    vsl: chargeDetailsearchCriteria.vsl ?? '',
                    voy: chargeDetailsearchCriteria.voy ?? '',
                    vel: chargeDetailsearchCriteria.vel ?? ''
                }}
                fieldConfiguration={{
                    co: { maxLength: 4, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    vsl: { maxLength: 10, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    voy: { maxLength: 10, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    vel: { maxLength: 10, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                }}
                onDataChange={(e: any) => chargeDetailVM.onCoVslVoyChange(e, {
                    co: 'co',
                    vsl: 'vsl',
                    voy: 'voy',
                    vel: 'vel'
                })} />
        </div>
        , [CONTAINER_CONSTANT.CONS_VSL_VOY_VESSEL_NAME, chargeDetailsearchCriteria.co, chargeDetailsearchCriteria.vsl, chargeDetailsearchCriteria.voy, chargeDetailsearchCriteria.vel, chargeDetailVM])

    if (!enabledCriteria) return null;

    return <>
        <CriteriaItemContainer>
            {chargeDetailState.enabledSearchCriteria.states ? memoState : null}
            {memoTruckerName}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDetailState.enabledSearchCriteria.chargeOnCompanies ? memoChargeOnCompany : null}
            {chargeDetailState.enabledSearchCriteria.billToCompanies ? memoBillToCompany : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDetailState.enabledSearchCriteria.chargeTypes ? <>{memoChgType}</> : null}
            {chargeDetailState.enabledSearchCriteria.chargeTypes ? <>{memoSubChgType}</> : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {memoOpsDateFromTo}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {memoCoVslVoyVesselName}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDetailState.enabledSearchCriteria.cntrNos ? memoCntrNo : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDetailState.enabledSearchCriteria.cntrSizes ? memoSize : null}
            {chargeDetailState.enabledSearchCriteria.cntrTypes ? memoType : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDetailState.enabledSearchCriteria.cntrStatus ? memoCntrStatus : null}
            {memoChargeCode}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDetailState.enabledSearchCriteria.adjTypes ? memoAdjType : null}
            {memoDamageType}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDetailState.enabledSearchCriteria.docNo ? memoInvNo : null}
            {memoBillOfLading}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {memoForwarder}
            {/*chargeDetailState.enabledSearchCriteria.marshallingTypes ? memoMarshallingTypes : null*/}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {memoPOO}
            {memoPOL}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {memoPOD}
            {memoFD}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {memoCNICNo}
            {memoVehicleNo}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {memoOriStatus}
            {memoNewStatus}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {memoServiceOrderCode}
            {memoServiceOrderNumber}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {memoServiceRequestCode}
            {memoSubServiceRequestCode}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {memoShippingBill}
            {memoAgentNo}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDetailState.enabledSearchCriteria.seqNo ? memoSeqNo : null}
            {memoServiceRequestRef}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDetailState.enabledSearchCriteria.opsLines ? memoOpsLine : null}
            {memoStorageMode}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {chargeDetailState.enabledSearchCriteria.trainId ? memoTrainId : null}
        </CriteriaItemContainer>
    </>;
}
export default memo(ChargeSearchForm);